module.exports = __webpack_public_path__ + "img/bugger_0428.b0f491a7.png";